import { Box } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import useGetTrialById from '../hooks/trial/useGetTrialById';
import { AggregatedSubmission, Enrollment } from '../redux/types';
import ApiClient from '../loopback/apiClient';
import { AuswertungSetting } from '../redux/types/auswertungSettingTypes';
import SurveyEvaluationResult from '../components/evaluation/SurveyEvaluationResult';

type MatchParams = {
  trialId: string;
  enrollmentId: string;
}

const EvaluationView = (): JSX.Element => {
  const params = useParams<MatchParams>();
  const { trialId, enrollmentId } = params;
  const trial = useGetTrialById(Number(trialId));
  const [enrollment, setEnrollment] = useState<Enrollment>();
  const [aggregatedSubmission, setAggregatedSubmission] = useState<AggregatedSubmission>();
  const [auswertungSetting, setAuswertungSetting] = useState<AuswertungSetting>();

  useEffect(() => {
    if (!enrollmentId) {
      return;
    }
    ApiClient.getAuswertungSetting(Number(trialId))
      .then((s) => setAuswertungSetting(s));
    ApiClient.getEnrollmentById(Number(enrollmentId))
      .then((e) => {
        setEnrollment(e);
        if (e.digitalGroundTruthGroupId) {
          return ApiClient.getAggregatedSubmissions(
            Number(trialId), e.digitalGroundTruthGroupId,
          );
        }
        return undefined;
      })
      .then((aggSubmission) => {
        setAggregatedSubmission(aggSubmission);
      });
  }, [trialId, enrollmentId]);

  if (!trial || !enrollment) {
    return <></>;
  }

  return (
    <Box>
      <SurveyEvaluationResult
        admin
        trialId={trial.id}
        trialName={trial.name}
        enrollmentId={enrollment.id}
        aggregatedSubmission={aggregatedSubmission}
        groundTruthGroupId={enrollment?.digitalGroundTruthGroupId}
        auswertungSetting={auswertungSetting}
      />
    </Box>
  );
};

export default EvaluationView;
